module.exports = __webpack_public_path__ + "static/img-15-d906807ed8766f7860f063457edede6a.jpeg";